import { render, staticRenderFns } from "./CommunityLeague.vue?vue&type=template&id=2b6bab13&"
import script from "./CommunityLeague.vue?vue&type=script&lang=js&"
export * from "./CommunityLeague.vue?vue&type=script&lang=js&"
import style0 from "./CommunityLeague.vue?vue&type=style&index=0&id=2b6bab13&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports